import { CommonModule } from '@angular/common';
import { Component, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmDialogData } from '@core/models/dialogs/dialog-data.model';
import { ConfirmationDialogResult } from '@core/models/dialogs/dialog-results.model';


@Component({
  selector: 'epod-confirm-popup',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, CommonModule, MatIconModule],
  templateUrl: './epod-confirm-popup.component.html',
  styleUrl: './epod-confirm-popup.component.scss'
})
export class EpodConfirmPopupComponent {

  private readonly _dialogRef = inject(MatDialogRef<EpodConfirmPopupComponent, ConfirmationDialogResult>);

  constructor(@Inject(MAT_DIALOG_DATA) public readonly dialogData: ConfirmDialogData) {
  }

  confirmButtonClick(): void {
    this._dialogRef.close({ wasConfirmed: true });
  }

  cancelButtonClick(): void {
    this._dialogRef.close({ wasConfirmed: false });
  }
}
